import {Link} from 'react-router';
import PropTypes from 'prop-types';
import React from 'react';

const Logo = ({entity, classes, toggleMenu, showBrandLogo}) => {
  const showSirLogo = !entity.logoUrl || (showBrandLogo && !entity.customBrandLogoUrl);
  let logoUrl;
  const onClick = (e) => {
    if (toggleMenu) {
      toggleMenu();
    }
  }
  if (showBrandLogo && entity.customBrandLogoUrl) {
    logoUrl = entity.customBrandLogoUrl;
  } else if (entity.logoUrl) {
    logoUrl = entity.logoUrl;
  }
  
  return (
    <div className={classes}>
      <div className="logo-wrapper">
        <Link to="/" onClick={onClick} aria-label="Sotheby's International Realty home">
          {showSirLogo ? 
            <div className="logo sothebys-logo"></div> :
            <div className="logo" style={{backgroundImage: `url(${logoUrl}?height=70)`}}></div>
          }
        </Link>
      </div>
    </div>
  );
};

Logo.defaultProps = {
  classes: ''
};

Logo.propTypes = {
  entity: PropTypes.object.isRequired,
  classes: PropTypes.string,
  showBrandLogo: PropTypes.bool,
  toggleMenu: PropTypes.func
};

export default Logo;



// WEBPACK FOOTER //
// ./src/components/shared/navbar/logo.js